module.exports = __webpack_public_path__ + "static/img/sj.ae547dbe.svg";